import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
/**
 * @COMPONENT_NAME MachineTimeSeriesData
 * @DESCRIPTION 설비의 시계열 데이터 이력을 관리하는 화면 컴포넌트
 *              설비별 시계열 데이터 이력 조회 화면을 제공
 */
function MachineTimeSeriesData ( props ) {

    return <BasicCrudScreenType noCreate noEdit noDelete noExcel id="MachineTimeSeriesData" table="MachineTimeSeriesData" view="VwMachineTimeSeriesData" />

}

export default MachineTimeSeriesData;
